// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ----- Page container ----- */
.settings-profile-page {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 24px 48px;
  overflow-y: auto;
  min-height: 0;
  background: linear-gradient(180deg, #e8f0f8 0%, #f0f4f8 40%, #fff 100%);
  font-family: "Figtree", -apple-system, BlinkMacSystemFont, sans-serif;
}

/* ----- Hero section ----- */
.settings-profile-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 28px;
  max-width: 520px;
}

.settings-profile-hero-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 16px;
  background: linear-gradient(135deg, #2C68A1 0%, #3d7ab8 100%);
  color: #fff;
  box-shadow: 0 8px 24px rgba(44, 104, 161, 0.25);
  margin-bottom: 12px;
}

.settings-profile-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a2332;
  margin: 0 0 8px;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.settings-profile-subtitle {
  font-size: 15px;
  color: #5c6573;
  margin: 0;
  line-height: 1.5;
  font-weight: 400;
}

.settings-profile-email {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 0;
  margin-bottom: 14px;
  padding: 10px 16px;
  background: #fff;
  border: 1px solid #2C68A1;
  border-radius: 10px;
  font-size: 14px;
  color: #2d333a;
  font-weight: 500;
}

.settings-profile-email-icon {
  font-size: 18px !important;
  color: #2C68A1;
}

/* ----- Main card ----- */
.settings-profile-card {
  width: 100%;
  max-width: 560px;
  background: #fff;
  border-radius: 16px;
  padding: 32px 28px 36px;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.05),
    0 10px 30px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);
}

/* ----- Form ----- */
.settings-profile-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* ----- Field card (each section) ----- */
.settings-field-card {
  background: #fafbfd;
  border: 1px solid #e8ecf1;
  border-radius: 12px;
  padding: 18px 20px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.settings-field-card:focus-within {
  border-color: rgba(44, 104, 161, 0.4);
  box-shadow: 0 0 0 3px rgba(44, 104, 161, 0.08);
}

.settings-field-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.settings-field-icon {
  color: #2C68A1;
  font-size: 22px !important;
}

.settings-field-card label {
  font-size: 15px;
  font-weight: 600;
  color: #2d333a;
  margin: 0;
  cursor: text;
}
.settings-textarea.text-heg{
    min-height: auto!important;
}




/* ----- Textareas ----- */
.settings-textarea {
  width: 100%;
  min-height: 110px;
  padding: 14px 16px;
  font-size: 15px;
  line-height: 1.55;
  font-family: "Figtree", -apple-system, BlinkMacSystemFont, sans-serif;
  color: #2d333a;
  background: #fff;
  border: 1px solid #e0e5eb;
  border-radius: 10px;
  outline: none;
  resize: vertical;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.settings-textarea::placeholder {
  color: #9ca3af;
}

.settings-textarea:hover {
  border-color: #c8cdd4;
}

.settings-textarea:focus {
  border-color: #2C68A1;
  box-shadow: 0 0 0 2px rgba(44, 104, 161, 0.12);
}

/* ----- Actions (Save button area) ----- */
.settings-profile-actions {
  padding-top: 8px;
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.settings-home-btn,
.settings-save-btn {
  min-width: 140px;
}

/* ----- Loading state ----- */
.settings-profile-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  padding: 40px 0;
}
.settings-profile-page.settings-profile-inn{
display: block;
padding: 20px;
}
.settings-profile-card.setting-profile-inn{
  max-width: 80%;
  padding: 20px;
}
.settings-textarea.setting-text-inn{
  min-height: 80px;
}
.header-profile-dropdown-school.underline-inner {
    text-decoration: underline;
}
.settings-profile-form.settings-profile-inn{
  gap: 12px;
}
/* ----- Responsive ----- */
@media (max-width: 600px) {
  .settings-profile-page {
    padding: 20px 16px 32px;
  }

  .settings-profile-hero-icon {
    width: 60px;
    height: 60px;
    border-radius: 16px;
  }

  .settings-profile-title {
    font-size: 24px;
  }

  .settings-profile-subtitle {
    font-size: 14px;
  }

  .settings-profile-card {
    padding: 24px 20px 28px;
    border-radius: 14px;
  }

  .settings-field-card {
    padding: 14px 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Settings/settingsProfile.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,uEAAuE;EACvE,qEAAqE;AACvE;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,WAAW;EACX,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB;;mCAEiC;EACjC,qCAAqC;AACvC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,YAAY;AACd;AACA;IACI,0BAA0B;AAC9B;;;;;AAKA,0BAA0B;AAC1B;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qEAAqE;EACrE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;AACA,cAAc;AACd,aAAa;AACb;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;IACI,0BAA0B;AAC9B;AACA;EACE,SAAS;AACX;AACA,2BAA2B;AAC3B;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* ----- Page container ----- */\n.settings-profile-page {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 32px 24px 48px;\n  overflow-y: auto;\n  min-height: 0;\n  background: linear-gradient(180deg, #e8f0f8 0%, #f0f4f8 40%, #fff 100%);\n  font-family: \"Figtree\", -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* ----- Hero section ----- */\n.settings-profile-hero {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  margin-bottom: 28px;\n  max-width: 520px;\n}\n\n.settings-profile-hero-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 72px;\n  height: 72px;\n  border-radius: 16px;\n  background: linear-gradient(135deg, #2C68A1 0%, #3d7ab8 100%);\n  color: #fff;\n  box-shadow: 0 8px 24px rgba(44, 104, 161, 0.25);\n  margin-bottom: 12px;\n}\n\n.settings-profile-title {\n  font-size: 28px;\n  font-weight: 700;\n  color: #1a2332;\n  margin: 0 0 8px;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n}\n\n.settings-profile-subtitle {\n  font-size: 15px;\n  color: #5c6573;\n  margin: 0;\n  line-height: 1.5;\n  font-weight: 400;\n}\n\n.settings-profile-email {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 0;\n  margin-bottom: 14px;\n  padding: 10px 16px;\n  background: #fff;\n  border: 1px solid #2C68A1;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #2d333a;\n  font-weight: 500;\n}\n\n.settings-profile-email-icon {\n  font-size: 18px !important;\n  color: #2C68A1;\n}\n\n/* ----- Main card ----- */\n.settings-profile-card {\n  width: 100%;\n  max-width: 560px;\n  background: #fff;\n  border-radius: 16px;\n  padding: 32px 28px 36px;\n  box-shadow:\n    0 1px 3px rgba(0, 0, 0, 0.05),\n    0 10px 30px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n/* ----- Form ----- */\n.settings-profile-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* ----- Field card (each section) ----- */\n.settings-field-card {\n  background: #fafbfd;\n  border: 1px solid #e8ecf1;\n  border-radius: 12px;\n  padding: 18px 20px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.settings-field-card:focus-within {\n  border-color: rgba(44, 104, 161, 0.4);\n  box-shadow: 0 0 0 3px rgba(44, 104, 161, 0.08);\n}\n\n.settings-field-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.settings-field-icon {\n  color: #2C68A1;\n  font-size: 22px !important;\n}\n\n.settings-field-card label {\n  font-size: 15px;\n  font-weight: 600;\n  color: #2d333a;\n  margin: 0;\n  cursor: text;\n}\n.settings-textarea.text-heg{\n    min-height: auto!important;\n}\n\n\n\n\n/* ----- Textareas ----- */\n.settings-textarea {\n  width: 100%;\n  min-height: 110px;\n  padding: 14px 16px;\n  font-size: 15px;\n  line-height: 1.55;\n  font-family: \"Figtree\", -apple-system, BlinkMacSystemFont, sans-serif;\n  color: #2d333a;\n  background: #fff;\n  border: 1px solid #e0e5eb;\n  border-radius: 10px;\n  outline: none;\n  resize: vertical;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.settings-textarea::placeholder {\n  color: #9ca3af;\n}\n\n.settings-textarea:hover {\n  border-color: #c8cdd4;\n}\n\n.settings-textarea:focus {\n  border-color: #2C68A1;\n  box-shadow: 0 0 0 2px rgba(44, 104, 161, 0.12);\n}\n\n/* ----- Actions (Save button area) ----- */\n.settings-profile-actions {\n  padding-top: 8px;\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.settings-home-btn,\n.settings-save-btn {\n  min-width: 140px;\n}\n\n/* ----- Loading state ----- */\n.settings-profile-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n  padding: 40px 0;\n}\n.settings-profile-page.settings-profile-inn{\ndisplay: block;\npadding: 20px;\n}\n.settings-profile-card.setting-profile-inn{\n  max-width: 80%;\n  padding: 20px;\n}\n.settings-textarea.setting-text-inn{\n  min-height: 80px;\n}\n.header-profile-dropdown-school.underline-inner {\n    text-decoration: underline;\n}\n.settings-profile-form.settings-profile-inn{\n  gap: 12px;\n}\n/* ----- Responsive ----- */\n@media (max-width: 600px) {\n  .settings-profile-page {\n    padding: 20px 16px 32px;\n  }\n\n  .settings-profile-hero-icon {\n    width: 60px;\n    height: 60px;\n    border-radius: 16px;\n  }\n\n  .settings-profile-title {\n    font-size: 24px;\n  }\n\n  .settings-profile-subtitle {\n    font-size: 14px;\n  }\n\n  .settings-profile-card {\n    padding: 24px 20px 28px;\n    border-radius: 14px;\n  }\n\n  .settings-field-card {\n    padding: 14px 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
